export default defineNuxtRouteMiddleware((to) => {
  const { can } = usePermissions()

  const findPermitted = (routes: Array<{ path: string; container?: string; action?: string }>): string => {
    const target = routes.find(
      (r) => !r.container || !r.action || can(r.container as 'schedule', r.action as 'list').value
    )
    return target?.path ?? '/403'
  }

  if (to.path === '/operations') {
    return navigateTo(
      findPermitted([
        { path: '/operations/schedules', container: 'schedule', action: 'list' },
        { path: '/operations/actions' },
        { path: '/operations/alert-rules', container: 'alert', action: 'list' }
      ])
    )
  }

  if (to.path === '/inventory') {
    return navigateTo(
      findPermitted([
        { path: '/inventory/groups', container: 'group', action: 'list' },
        { path: '/inventory/sites', container: 'site', action: 'list' },
        { path: '/inventory/assets' }
      ])
    )
  }

  if (to.path === '/settings') {
    return navigateTo(findPermitted([{ path: '/settings/users', container: 'user_management', action: 'list' }]))
  }
})
